import { useWorkplaceAnalyticsFlag } from "@src/appV2/redesign/WorkplaceAnalytics/hooks/useWorkplaceAnalyticsFlag";
import { CbhFeatureFlag, useCbhFlag } from "src/appV2/FeatureFlags";

/**
 * The Corporate Administrator role is assignable once any corporate-level
 * feature (Spend Controls or Workplace Analytics) is launched to customers.
 */
export function useShouldShowCorporateAdminRole(): boolean {
  const spendingControlsConfig = useCbhFlag(CbhFeatureFlag.CONFIGURE_SPENDING_CONTROLS, {
    defaultValue: { enabled: false },
  });
  const workplaceAnalyticsFlag = useWorkplaceAnalyticsFlag();

  return (
    (spendingControlsConfig.enabled && !spendingControlsConfig.internalUseOnly) ||
    (workplaceAnalyticsFlag.enabled && !workplaceAnalyticsFlag.internalUseOnly)
  );
}
